// extracted by mini-css-extract-plugin
module.exports = {"header":"TableView_header__25y6Y","avatar":"TableView_avatar__3Na_V"};